<template>
	<div
		@mouseenter="isHovering = true"
		@mouseleave="isHovering = false"
		:class="[{ 'no-border': noBorder }]"
		class="action-details-container display-flex flex-column width-100 flex-align-center py-2"
	>
		<div class="display-flex flex-row width-100 flex-align-center width-100 flex-justify-space-between content-container">
			<div class="display-flex flex-row width-100 flex-align-center">
				<SIcon name="action-details-bullet" class="mr-2 icon-container" />
				<div class="title-text mr-2">Action:</div>
				<div class="description-text">{{ action.action_title }}</div>
			</div>
			<AppDropdownMenu left bottom absolute min-width="215" :nudge-bottom="10" :items="optionsMenuItems">
				<template #activator="{ value }">
					<v-btn v-if="showDropdownButton && (value || isHovering)" icon x-small rounded width="20" height="20">
						<SIcon class="menu-button" name="menu-button" width="20" />
					</v-btn>
				</template>
			</AppDropdownMenu>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getNode } from '@/store/modules/nodes/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { editNode } from '@/store/modules/selectedNode/getters';
import { BLOCK_EDITOR_ROUTE_NAME } from '@/router/router.const.js';
import { useIsTaskLogOpen } from '@/store/modules/analytics/getters.js';
import { isVersionHistoryOpen } from '@/store/modules/workflows/modules/versions/getters.js';
import WorkflowVersionService from '@/components/WorkflowVersionHistory/workflow-version-service';
export default {
	name: 'ActionDetailsItem',
	props: {
		action: { type: Object },
		noBorder: { type: Boolean },
	},
	computed: {
		...mapGetters([getNode.fullPath, editNode.fullPath]),
		...mapGettersShorthand({ isVersionHistoryOpen, useIsTaskLogOpen }),
		optionsMenuItems() {
			return [{ text: `Edit step`, onClick: this.editStep }];
		},
		editNode() {
			return this[editNode.fullPath];
		},
		isActionInEditMode() {
			return this.editNode.id === this.action.id;
		},
		showDropdownButton() {
			const routePrefix = WorkflowVersionService.getRoutePrefix({
				isVersionHistoryOpen,
				isViewingTaskLog: this.useIsTaskLogOpen(this.$route),
			});
			return !this.isActionInEditMode && this.$route.name === `${routePrefix}${BLOCK_EDITOR_ROUTE_NAME}`;
		},
	},
	methods: {
		...mapActions(['selectedNode/setEditNodeClick']),
		editStep() {
			return this['selectedNode/setEditNodeClick'](this[getNode.fullPath](this.action.id));
		},
	},
	data() {
		return {
			isHovering: false,
		};
	},
};
</script>

<style lang="scss" scoped>
.action-details-container {
	border-bottom: 1px solid var(--faded-regular-border);

	&.no-border {
		border: 0px !important;
	}

	&:hover {
		background: var(--app-selection-hover-background);
	}
}

.title-text {
	font-weight: normal;
	font-size: 12px;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 12px;
	color: var(--secondary-font-color);
}

.icon-container {
	margin-top: 2px;
}
.menu-button {
	margin-top: 3px;
	margin-right: 2px;
}
.content-container {
	height: 18px;
}
</style>
